<template>
  <v-dialog v-model="missingDialog" persistent max-width="1300">
    <v-card class="mx-auto">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Check Missing Rate Plan</v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          :search.sync="search"
        >
          <template v-slot:item.action="{ item }">
            <v-btn color="primary" @click="addRatePlan(item)">
              Add Rate Plan
            </v-btn>
          </template>
        </v-data-table>
        <v-card-actions class="mt-1">
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">close</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <add-rate-plan
      ref="addMissingRatePlan"
      @init="fetchMissingPlan"
    ></add-rate-plan>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import RatePlan from "@/models/RatePlan";
import ruleDetail from "@/components/commissions/ruleDetail";
import addRatePlan from "@/components/commissions/AddRatePlan";

export default {
  name: "MissingPlans",
  components: {
    ruleDetail,
    addRatePlan,
  },
  props: {
    missingDialog: Boolean,
  },
  data() {
    return {
      dialog: false,
      runType: 1,
      search: null,
      items: [],
      rules: [],
      editedItem: {},
      headers: [
        {
          text: "Rate Plan ID",
          value: "ratePlanID",
          align: "left",
          sortable: true,
          class: ["strong"],
        },
        {
          text: "Description",
          value: "ratePlanDescription",
          align: "left",
          sortable: true,
          class: ["strong"],
        },
        {
          text: "Group Name",
          value: "groupName",
          align: "left",
          sortable: true,
          class: ["strong"],
        },
        {
          text: "Actions",
          value: "action",
          align: "left",
          sortable: false,
          width: 100,
          class: ["strong"],
        },
      ],
    };
  },
  watch: {
    missingDialog(val) {
      if (val == true) {
        this.fetchMissingPlan();
      }
      return val;
    },
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),
    fetchMissingPlan() {
      let query = {
        message: `Missing RatePlans collected`,
        url: `Commissions/GetMissingRatePlans`,
        method: "get",
        body: {},
      };
      this.CommissionsRequest(query)
        .then((data) => {
          this.items = data;
        })
        .catch(() => {});
    },
    addRatePlan(val) {
      this.$refs.addMissingRatePlan.populate(val);
    },
    closeDialog() {
      this.items = [];
      this.search = null;
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped></style>
